
import Msg from 'vux/src/components/msg/index.vue'

import mixinTxrNewWeb from '@/utils/mixin/mixinTxrNewWeb'

export default {
mixins: [mixinTxrNewWeb],
data() {
return {

title:'领取成功!',
desc:'保单已经生效啦，祝您美颜永驻~',
list:[
'关注微信公众号<span class="bold">「保栈」</span>',
'进入 <span class="bold">个人中心</span> 找到购买的产品使用服务'
]
}
},
components: {
Msg,
},
computed: {
templateFlag() {
return this.$route.query.templateFlag || "";
},
uuid() {
return this.$route.query.uuid || "";
},
outTrade(){
return this.$route.query.outTrade || "";

},
info(){
if(this.$route.query.state==1){
return {
icon:'https://static.soyoung.com/sy-design/2hca637nb8ad51735032613858.png',
title:'领取成功!',
desc:'保单已经生效啦，祝您美颜永驻~',
more:'使用流程',
list:[
'关注微信公众号<span class="bold">「保栈」</span>',
'进入 <span class="bold">个人中心</span> 找到购买的产品使用服务'
]
}
}else{

return {
icon:'https://static.soyoung.com/sy-pre/iohvei54814e-1636117800691.png',
title:'活动已结束～',
desc:'',
more:'更多福利',
list:[
'关注微信公众号<span class="bold">「保栈」</span>',
'更多优惠活动、精彩内容，尽在掌握~'
]
}
}

}
},
beforeDestroy() {
window.clearInterval(this.timer);
window.clearInterval(this.timeDelayer);
this.$loading.hide()
/** 离开组件时，强制结束录制 */



},

mounted () {


if(this.$route.query.state==1){

this.STATISTICS_CONFIG.insur_success_page()
this.operatingTX()
}else{

document.title = '活动已结束'
this.STATISTICS_CONFIG.insur_finish_page()
}
},
methods: {

},
}
